import { render, staticRenderFns } from "./UsageSuper.vue?vue&type=template&id=62163206"
import script from "./UsageSuper.vue?vue&type=script&lang=js"
export * from "./UsageSuper.vue?vue&type=script&lang=js"
import style0 from "./UsageSuper.vue?vue&type=style&index=0&id=62163206&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports